// ==================== 部门选项 ====================
export const DEPARTMENT_OPTIONS = [
  { label: "Managing Director", value: "0001" },
  { label: "Purchasing", value: "0002" },
  { label: "Sales", value: "0003" },
  { label: "Organization", value: "0004" },
  { label: "Administration", value: "0005" },
  { label: "Production", value: "0006" },
  { label: "Quality assurance", value: "0007" },
  { label: "Secretaries", value: "0008" },
  { label: "Financial department", value: "0009" },
  { label: "Legal department", value: "0010" },
];

export const CONTRACT_CATEGORY_OPTIONS = [
  { label: "生产物料", value: "C1" },
  { label: "非生产物料", value: "C2" },
  { label: "其他", value: "C0" },
];

export const CONTRACT_CATEGORY_OPTIONS_PO = [
  { label: "A,B类物料", value: "AB" },
  { label: "C,D类和中试物料", value: "CD" },
];

export const CONTRACT_SUB_CATEGORY_OPTIONS = [
  { label: "生產物料相關合同", value: "C1_1" },
  { label: "新項目和工程建設相關合同", value: "C2_1" },
  { label: "設施/設備/儀器相關合同", value: "C2_2" },
  { label: "易耗品相關合同", value: "C2_3" },
  { label: "外包服務相關合同", value: "C2_4" },
  { label: "行政相關合同", value: "C2_5" },
  { label: "SO相關合同", value: "C2_6" },
  { label: "HR相關合同", value: "C2_7" },
  { label: "財務相關合同", value: "C2_8" },
  { label: "其他", value: "C0_0" },
];

export const CONTRACT_DESC_OPTIONS = [
  { label: "物料採購框架協議", value: "物料採購框架協議" },
  { label: "保密協議", value: "保密協議" },
  { label: "物料採購返利協議", value: "物料採購返利協議" },
  { label: "土建項目合同", value: "土建項目合同" },
  { label: "裝修合同", value: "裝修合同" },
  { label: "設施/設備/儀器採購合同", value: "設施/設備/儀器採購合同" },
  { label: "零配件/模具採購合同", value: "零配件/模具採購合同" },
  { label: "外包服務合同", value: "外包服務合同" },
  { label: "設施採購合同", value: "設施採購合同" },
  { label: "設備採購合同", value: "設備採購合同" },
  { label: "儀器採購合同", value: "儀器採購合同" },
  { label: "模具採購合同", value: "模具採購合同" },
  { label: "供應商開模合同", value: "供應商開模合同" },
  { label: "生產易耗品採購合同", value: "生產易耗品採購合同" },
  { label: "實驗室易耗品採購合同", value: "實驗室易耗品採購合同" },
  { label: "設備備品備件採購合同", value: "設備備品備件採購合同" },
  { label: "行政清潔用品採購合同", value: "行政清潔用品採購合同" },
  { label: "辦公用品採購合同", value: "辦公用品採購合同" },
  { label: "IT易耗品採購合同", value: "IT易耗品採購合同" },
  { label: "維護保養合同", value: "維護保養合同" },
  { label: "防蟲服務合同", value: "防蟲服務合同" },
  { label: "租賃合同", value: "租賃合同" },
  { label: "顧問服務合同", value: "顧問服務合同" },
  { label: "廠車、保安、飯商服務合同", value: "廠車、保安、飯商服務合同" },
  { label: "車輛維修合同", value: "車輛維修合同" },
  { label: "辦公室、宿舍裝修和維修合同", value: "辦公室、宿舍裝修和維修合同" },
  { label: "IT硬體採購合同", value: "IT硬體採購合同" },
  { label: "IT軟體採購合同", value: "IT軟體採購合同" },
  { label: "IT服務合同", value: "IT服務合同" },
  { label: "人員招聘合同", value: "人員招聘合同" },
  { label: "員工體檢合同", value: "員工體檢合同" },
  { label: "醫療保险服務合同", value: "醫療保险服務合同" },
  { label: "財務、法務相关顧問服務合同", value: "財務、法務相关顧問服務合同" },
  { label: "併購合同", value: "併購合同" },
  { label: "銀行受信文件", value: "銀行受信文件" },
  { label: "與科技園租務相關合同", value: "與科技園租務相關合同" },
  {
    label: "未包含在上述表格中的采購合同",
    value: "未包含在上述表格中的采購合同",
  },
  { label: "其他", value: "其他" },
];
